import { useState } from 'react';
import type { SalespersonOption } from '../../types/portal';
import styles from './AssignModal.module.css';

interface AssignModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAssign: (data: { assignee: string; category: string; notes: string }) => void;
  salespersons?: SalespersonOption[];
}

const AssignModal: React.FC<AssignModalProps> = ({ isOpen, onClose, onAssign, salespersons }) => {
  const [assignee, setAssignee] = useState('');
  const [notes, setNotes] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!assignee) {
      alert('Please select a person to assign');
      return;
    }
    onAssign({ assignee, category: '', notes });
    setAssignee('');
    setNotes('');
  };

  const handleClose = () => {
    setAssignee('');
    setNotes('');
    onClose();
  };

  return (
    <div className={`${styles.overlay} ${isOpen ? styles.open : ''}`} onClick={handleClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <span className={styles.title}>Assign Email Thread</span>
          <button className={styles.close} onClick={handleClose} type="button">
            &times;
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className={styles.body}>
            <div className={styles.formGroup}>
              <label className={styles.label}>Assign to</label>
              <select
                className={styles.select}
                value={assignee}
                onChange={(e) => setAssignee(e.target.value)}
              >
                <option value="">Select a person...</option>
                {salespersons && salespersons.length > 0 ? (
                  <optgroup label="Sales Representatives">
                    {salespersons.map((sp) => (
                      <option key={sp.salesperson_no} value={sp.salesperson_no}>
                        {sp.name} ({sp.salesperson_no})
                      </option>
                    ))}
                  </optgroup>
                ) : (
                  <>
                    <optgroup label="Customer Support Reps">
                      <option value="CS-Sarah">Sarah M. (Customer Support)</option>
                      <option value="CS-Mike">Mike T. (Customer Support)</option>
                      <option value="CS-Lisa">Lisa R. (Customer Support)</option>
                    </optgroup>
                    <optgroup label="Sales Representatives">
                      <option value="JF">John Fauth (JF)</option>
                      <option value="WA">Weemhoff - Ohio (WA)</option>
                      <option value="DO">Dornseif (DO)</option>
                      <option value="CP">Cliff Platt (CP)</option>
                      <option value="DS">DiStefano Sales (DS)</option>
                      <option value="PM">Bill Dugan (PM)</option>
                    </optgroup>
                  </>
                )}
              </select>
            </div>
            <div className={styles.formGroup}>
              <label className={styles.label}>Notes (optional)</label>
              <input
                type="text"
                className={styles.input}
                placeholder="Add any notes for the assignee..."
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />
            </div>
          </div>
          <div className={styles.footer}>
            <button className={`${styles.btn} ${styles.btnOutline}`} onClick={handleClose} type="button">
              Cancel
            </button>
            <button className={`${styles.btn} ${styles.btnPrimary}`} type="submit">
              Assign
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AssignModal;
